import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import syslic from '@/syslic'

const fetchRegionalBiddingData = async (vm = null) => {
  try {
    const profile = syslic.authentication.getProfile()
    if (!profile || !profile.id) throw new Error('ID do usuário não encontrado')

    const userID = profile.id
    // const url = `http://localhost:5000/Reports/RetrieveReportByState?userID=${userID}`
    const url = `https://syslic.com.br/reports/RetrieveReportByState?userID=${userID}`
    const response = await axios.get(url)

    return response.data
  } catch (error) {
    let errorMessage = 'Erro desconhecido ao buscar dados regionais'

    if (error.response) {
      errorMessage = error.response.data?.message
      || error.response.statusText
      || `Erro ${error.response.status}`
    } else if (error.request) {
      errorMessage = 'O servidor não respondeu. Verifique sua conexão.'
    } else {
      errorMessage = error.message
    }

    if (vm?.$toast) {
      vm.$toast({
        component: ToastificationContent,
        props: {
          title: 'Falha na requisição',
          text: errorMessage,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
          timeout: 5000,
        },
      })
    }

    return { labels: [], datasets: [] }
  }
}

export default fetchRegionalBiddingData
